import Fuse from "fuse.js";
import allGuides from "../../pages/Wiki/Guides/guidesIndex";

const options = {
  keys: [
    { name: "title", weight: 0.5 },
    { name: "meta.description", weight: 0.4 },
    { name: "meta.keywords", weight: 0.3 },
    { name: "sections.title", weight: 0.4 },
    { name: "sections.content.title", weight: 0.3 },
    { name: "sections.content.data", weight: 0.2 },
    { name: "sections.content.content.title", weight: 0.2 },
    { name: "sections.content.content.data", weight: 0.1 },
    { name: "sections.content.content.content.title", weight: 0.2 },
    { name: "sections.content.content.content.data", weight: 0.1 },
  ],
  threshold: 0.1, // More strict than 0.5
  includeMatches: true,
  minMatchCharLength: 3,
  ignoreLocation: false, // Only match from start of words
  findAllMatches: true,
};

const fuse = new Fuse(allGuides, options);

const useGuideSearch = () => {
  const searchGuides = (query) => {
    if (!query.trim()) return [];

    const results = fuse
      .search(query)
      .filter((result) => {
        // Only keep results with valid matches
        return result.matches && result.matches.length > 0;
      })
      .map((result) => {
        const guide = result.item;
        if (!guide) return null;

        // // Debug log to see why items match
        // console.log(`Match for "${query}" in "${guide.title}":`, {
        //   matches: result.matches.map((m) => ({
        //     field: m.key,
        //     value: m.value,
        //     score: m.score,
        //   })),
        // });

        // Simple URL builder - modify as needed
        const buildUrl = () => {
          if (guide.override) return `/${guide.override}`;

          const baseUrl = `/wiki/${guide.slug || guide.id}`;

          // Try to find a section-related match first
          const sectionMatch = result.matches.find((m) => m.key.startsWith("sections.") && (m.key.includes(".title") || m.key.includes(".content.title")));

          if (sectionMatch) {
            const pathParts = sectionMatch.key.split(".");
            const sectionIndex = parseInt(pathParts[1]);
            if (!isNaN(sectionIndex) && guide.sections?.[sectionIndex]) {
              const section = guide.sections[sectionIndex];
              return `${baseUrl}/${section.id}`;
            }
          }

          // If no section match, return guide base
          return baseUrl;
        };

        return {
          ...guide,
          url: buildUrl(),
          matches: result.matches,
          score: result.score,
          matchDetails: result.matches.map((match) => ({
            field: match.key,
            matchedText: match.value,
            highlight: match.indices?.[0] || [],
          })),
        };
      })
      .filter(Boolean); // Remove any null results

    // console.log(`Final results for "${query}":`, results);
    return results;
  };

  return { searchGuides };
};

export default useGuideSearch;
